<template>
  <div>
    <v-card class="mx-auto" v-if="!frmcadastro">
      <v-toolbar color="#2A3F54" class="tbTitle" dark>
        <v-toolbar-title>Serviços</v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-btn color="primary" dark class="mb-2" @click="openform('novo')" :disabled="!permissoes.perfil_incluir">Novo Serviço</v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        v-model="selected"
        locale="pt-BR"
      >
        <template v-slot:item="props">
          <tr @dblclick="openform('editar',props.item.id)">
            <td class="text-xs-right">{{ props.item.tipo }}</td>
            <td class="text-xs-right">{{ props.item.valor }}</td>
          </tr>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >Sua Pesquisa por "{{ search }}" não encontrou registros.</v-alert>
      </v-data-table>
    </v-card>
    <v-card class="mx-auto" v-if="frmcadastro">
      <v-toolbar color="#2A3F54" class="tbTitle" dark>
        <v-toolbar-title>{{titulo}}</v-toolbar-title>
      </v-toolbar>

      <v-form @submit.prevent="salvar()">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="frmcadastro=false; getData();">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                label="Tipo Serviço"
                v-model="servico.tipo_id"
                :items="tiposerv"
                item-text="nome"
                item-value="id"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-text-field label="Valor" name="valor" v-model="servico.valor"></v-text-field>
            </v-col>            
          </v-row>
          <v-alert
            dense
            outlined
            type="error"
            v-for="(erro, index) of erros"
            :key="index"
          >{{erro[0]}}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn depressed color="error" @click="confirmaExcluir()" v-if="excluir" :disabled="!permissoes.catalogo_excluir">EXCLUIR</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" type="submit" :disabled="!permissoes.catalogo_alterar">SALVAR</v-btn>
        </v-card-actions>
        <template>
          <v-row justify="center">
            <v-dialog v-model="exclusao" persistent max-width="400">
              <v-card>
                <v-card-title class="headline">Atenção</v-card-title>
                <v-card-text>Deseja realmente excluir este Serviço?</v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="red darken-1" text @click="exclusao = false">NÃO</v-btn>
                  <v-btn color="blue darken-1" text @click="deletar()">SIM</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-form>
    </v-card>
  </div>
</template>
<script>
export default {
  components: {},
  props: ["catalogo_id"],
  data() {
    return {
      selected: [],
      search: "",
      headers: [
        { text: "Tipo Serviço", value: "tipo", align: "left" },
        { text: "Valor", value: "valor" }
      ],
      items: [],
      frmcadastro: false,
      excluir: false,
      exclusao: false,
      readonly: true,
      titulo: String,
      erros: [],
      tiposerv: [],
      servico: {
        id: 0,
        catalogo_id: 0,
        tipo_id: 0,
        valor: 0
      },
      permissoes: {
        catalogo: false,
        catalogo_incluir: false,
        catalogo_alterar: false,
        catalogo_excluir: false
      }
    };
  },
  created: function() {
    this.getData();

    let permAux = this.$store.getters.getPermissoes;

    if (permAux.ativo) {
      this.permissoes = permAux;
      if (!this.permissoes.catalogo) this.$router.push("/#");
    }
    else
    this.$router.push("/#");

  },
  methods: {
    getData: function() {
      this.$http
        .get(this.$urlAPI + "/servico/" + this.catalogo_id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.items = response.data));

      this.$http
        .get(this.$urlAPI + "/tipo", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.tiposerv = response.data));
    },
    openform: function(opcao, id) {
      this.frmcadastro = true;
      this.erros = [];
      if (opcao == "novo") {
        this.excluir = false;
        this.titulo = "Novo Serviço";
        this.servico = {
          id: 0,
          tipo_id: 0,
          catalogo_id: this.catalogo_id,
          valor: 0
        };
      } else if (opcao == "editar") {
        this.excluir = true;
        this.titulo = "Editar Serviço";

        this.$http
          .get(this.$urlAPI + "/servico/show/" + id, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            this.servico = response.data;
          });
      }
    },
    salvar: function() {
      if (this.excluir) {
        this.$http
          .post(
            this.$urlAPI + "/servico/" + this.servico.id,
            this.servico,
            {
              headers: {
                authorization: "Bearer " + this.$store.getters.getToken
              }
            }
          )
          .then(response => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      } else {
        this.$http
          .post(this.$urlAPI + "/servico", this.servico, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      }
    },
    confirmaExcluir: function() {
      this.exclusao = true;
    },
    deletar: function() {
      this.$http
        .delete(this.$urlAPI + "/servico/" + this.servico.id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          if (response.data.status) {
            this.frmcadastro = false;
            this.exclusao = false;
            this.getData();
          } else {
            this.erros = null;
            this.erros = response.data.erros;
          }
        })
        .catch(e => {
          this.erros = e.response.data.erros;
        });
    }
  }
};
</script>
